<template>
	<es-layout
		leftArrow="{{true}}"
		navbarTitle="退款详情"
		navbarStyle="{{navbarStyle}}"
		esMainStyle="{{esMainStyle}}"
		navbarUseRight="{{isShowDiscount}}"
	>
		<view bindtap="showDrawer" slot="narbar-right">规则</view>
		<view class="header">
			<es-icon size="22" name="coin-circle"></es-icon>
			<view class="info">
				<view class="info-content">退款总额：{{refundTotal}}元</view>
				<view class="info-tip">通过其他途径改签或退票产生的退款</view>
			</view>
			<view wx:if="{{refunds.length}}" bindtap="refundConfirm" class="btn">立即退款</view>
		</view>
		<view class="content">
			<view wx:for="{{refunds}}" wx:key="index" class="refund">
				线下改签退票退款：<view class="price">{{item.return_price}}</view>元
			</view>
			<view wx:if="{{isShowDiscount}}" class="refund">
				订单优惠金额扣减：<view class="price">-{{discountTotal}}</view>元
			</view>
		</view>
	</es-layout>
	<!-- 浮层部分 -->
	<drawer-frame title="退改规则说明" open="{{openDrawer}}" bind:closeDrawer="closeDrawer">
		<view class="refund-desc-container">
			<view wx:for="{{refundOfflineDesc}}" class="desc-item">{{item}}</view>
		</view>
	</drawer-frame>
  <es-dialog id="es-dialog"></es-dialog>
</template>

<script>
 	import { mpx, createPage } from '@didi/es-mpx-creator'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import { getOfflineRefundFeeDetail, applyOfflineRefund } from '@/api/order-detail/index'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'
  import { getFinalPrice } from '@/utils/money'
  import { isFastDoubleClick } from '@/utils/double-click'
  import { innerRouter, pagePath } from '@/common/jump'
	import { refundOfflineDesc } from './config'

 	createPage({
 		data() {
 			return {
				refunds: [],
				refundTotal: 0,
				discountTotal: 0,
				openDrawer: false,
				refundOfflineDesc,
				orderId: null
 			}
 		},
		ready() {
			const { order_id } = this.$mpxRoute.query || {}
			this.orderId = order_id
			getOfflineRefundFeeDetail({
				order_id
			}).then(res => {
				const { data, message, code, success } = res || {}
				if (success && code === '0') {
					this.refunds = data.offline_refund_fee_detail?.map(item => ({
						...item,
						return_price: getFinalPrice(item.return_price)
					})) || []
					this.refundTotal = getFinalPrice(data.total_return_price || 0)
					this.discountTotal = getFinalPrice(data.total_discount_amount || 0)
				} else {
					this.showRequestErrorToast(message)
				}
			}).catch(err => {
				this.showRequestErrorToast()
			})
		},
 		computed: {
      esMainStyle() {
        return {
					'background-image': 'linear-gradient(180deg, #1473ff 0%, #1473ff 30%, #f0f1f4 30%, #f0f1f4 100%)'
				}
      },
			// 是否透传券减免信息
			isShowDiscount() {
				return !!Number(this.discountTotal || 0)
			},
 			navbarStyle() {
 				return {
 					color: '#fff',
 					fontSize: '18px',
 					fontWeight: 600,
 					background: '#1473ff',
 					fontFamily: 'PingFangSC',
 				}
 			}
 		},
		methods: {
			showDrawer() {
				this.openDrawer = true
			},
			closeDrawer() {
				this.openDrawer = false
			},
      showRequestErrorToast(message) {
        mpx.showToast({
          title: message || LOAD_FAIL_CONTENT,
          icon: 'error'
        })
      },
			refundConfirm() {
        if (isFastDoubleClick()) {
          return
        }
				Dialog.alert({
					title: '确认退款',
					message: '您的订单已通过其他途径办理过改签或退票，银行将在1-15工作日把钱款退至原支付账户，若逾期未收到退款，请致电银行客服',
					confirmButtonText: '知道了',
					confirm: () => {
            if (isFastDoubleClick()) {
              return
            }
						const order_id = this.orderId
						applyOfflineRefund({
							order_id,
							apply_ids: JSON.stringify(this.refunds.map(({apply_id}) => apply_id))
						}).then(res => {
							const { data, message, code, success } = res || {}
							if (success && code === '0') {
								const { from = '' } = this.$mpxRoute.query
								innerRouter.goback()
							} else {
								this.showRequestErrorToast(message)
							}
						}).catch(err => {
							this.showRequestErrorToast()
						})
					}
				})
			}
		},
 	})
</script>

<style lang="stylus" scoped>
	.header
		height 68px
		padding 16px 15px 0 24px
		display flex
		align-items flex-start
		justify-content space-between
		color #fff
		letter-spacing 0px
		.info
			flex 1
			padding 0 4px
			&-content
				font-family PingFangSC-Semibold
				font-size 18px
				line-height 22px
			&-tip
				margin-top 5px
				font-family PingFangSC-Regular
				font-size 12px
				line-height 18px
		.btn
			flex none
			width 98px
			height 36px
			display flex
			align-items center
			justify-content center
			border 1px solid #FFFFFF
			background-color transparent
			border-radius 8px
			font-family PingFangSC-Medium
			font-size 14px
	.content
		padding 12px 12px 40px
		min-height 50vh
		border-radius 16px 16px 0 0
		background-image linear-gradient(179deg, #FAFBFD 0%, #F0F1F4 6%, #F0F1F4 100%)
		.refund
			height 50px
			border-radius 8px
			background-color #fff
			display flex
			align-items center
			font-size 16px
			font-family PingFangSC-Medium
			letter-spacing 0px
			color #000000
			padding 0 12px
			&+.refund
				margin-top 10px
			.price
				display inline
				color #1473FF
	.refund-desc-container
		margin 0 12px
		padding 8px 12px
		margin-bottom 32px
		.desc-item
			margin-bottom 8px
			font-family PingFangSC-Regular
			line-height 18px
			color #666
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'drawer-frame': '@/components/coupon/drawer-frame'
    }
  }
</script>
